import autoLogin from './actions/autoLogin';
import logout from './actions/logout';
import signIn from './actions/signIn';
import accessToken from './getters/accessToken';
import authUser from './mutations/authUser';
import clearSession from './mutations/clearSession';

const actions = {
    autoLogin,
    signIn,
    logout
};

const mutations = {
    authUser,
    clearSession
};

const getters = {
    accessToken
};

export default { actions, mutations, getters };
